import { DataSource, Layout, Table } from "@mcleod/components";

export abstract class AutogenLayoutAddBrokerageCodeMap extends Layout {
    sourceMapBrokerageCode: DataSource;
    tableAddBrokerageMappings: Table;
}
